<script>
  import "@vueform/multiselect/themes/default.css";
  import "flatpickr/dist/flatpickr.css";

import {getScheduler} from '@/api/user'

  import Layout from "../../layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import appConfig from "../../../app.config";
  import animationData from "@/components/widgets/msoeawqm.json";
  import Lottie from "@/components/widgets/lottie.vue";

  export default {
    page: {
      title: "List View",
      meta: [{
        name: "description",
        content: appConfig.description
      }],
    },
    data() {
      return {
        title: "List View",
        items: [{
            text: "Tasks",
            href: "/",
          },
          {
            text: "List View",
            active: true,
          },
        ],
        defaultOptions: {
          animationData: animationData
        },
        allTask: [],
        searchQuery: null,
        page: 1,
        perPage: 100,
        pages: [],
      };
    },
    components: {
      Layout,
      PageHeader,
      lottie: Lottie,
    },
    computed: {
      displayedPosts() {
        return this.paginate(this.allTask);
      },
      resultQuery() {
        if (this.searchQuery) {
          const search = this.searchQuery.toLowerCase();
          return this.displayedPosts.filter((data) => {
            return (
              data.name.toLowerCase().includes(search)
            );
          });
        } else {
          return this.displayedPosts;
        }
      },
    },
    watch: {
      allTask() {
        this.setPages();
      },
    },
    created() {
      this.setPages();
    },
    filters: {
      trimWords(value) {
        return value.split(" ").splice(0, 20).join(" ") + "...";
      },
    },
    beforeMount() {

      getScheduler().then(data => {
        console.log(data)
        this.allTask = [];
       
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep",
          "Oct", "Nov", "Dec"
        ];
        data.forEach(row => {
          var dd = new Date(row.last_run_time)
          row.last_run_time = dd.getHours() + ":" + dd.getMinutes() + ":" + dd.getSeconds() + " " + dd.getDate() + " " + monthNames[dd.getMonth()] + ", " + dd.getFullYear();
          
          console.log(row)
          this.allTask.push(row);
        })
      }).catch(er => {
        console.log(er)
      })

    },

    methods: {
      setPages() {
        let numberOfPages = Math.ceil(this.allTask.length / this.perPage);
        this.pages = [];
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
      },
      paginate(allTask) {
        let page = this.page;
        let perPage = this.perPage;
        let from = page * perPage - perPage;
        let to = page * perPage;
        return allTask.slice(from, to);
      },
    },
    mounted() {
      
    },
  };
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="tasksList">
          <div class="card-body">
            <div class="table-responsive table-card mb-4">
              <table class="table align-middle table-nowrap mb-0" id="tasksTable">
                <thead class="table-light text-muted">
                  <tr>
                    <!-- <th class="sort" data-sort="id">{{ $t("riskctrl-task-id") }}</th> -->
                    <th class="sort" data-sort="task_name">{{ $t("riskctrl-task-name") }}</th>
                    <th class="sort" data-sort="trigger_type">{{ $t("riskctrl-task-trigger-type") }}</th>
                    <th class="sort" data-sort="interval">{{ $t("riskctrl-task-interval") }}</th>
                    <th class="sort" data-sort="last_run_time">{{ $t("riskctrl-task-run-time") }}</th>
                    <th class="sort" data-sort="count">{{ $t("riskctrl-task-count") }}</th>
                    <th class="sort" data-sort="status">{{ $t("riskctrl-task-status") }}</th>
                    <!-- <th class="sort" data-sort="comment">{{ $t("riskctrl-task-comment") }}</th>
                    <th class="sort" data-sort="create_time">{{ $t("riskctrl-task-create-time") }}</th> -->
                  </tr>
                </thead>
                <tbody class="list form-check-all">
                  <tr v-for="(task, index) of resultQuery" :key="index">
                    <!-- <td class="id">
                      <router-link to="/riskctrl/tasks-details" class="fw-medium link-primary">{{ task.taskId }}
                      </router-link>
                    </td> -->
                    <td class="task_name">{{ task.name }}</td>
                    <td class="trigger_type">{{ task.trigger_type }}</td>
                    <td class="interval">{{ task.interval }}</td>
                    <td class="last_run_time">{{ task.last_run_time }}</td>
                    <td class="count">{{ task.count }}</td>
                    <td class="status">
                      <span class="badge" :class="{
                          'badge-soft-danger':task.status=='error',
                          'badge-soft-info':task.status=='runing',
                          'badge-soft-success':task.status=='finish',
                        }">{{
                        task.status
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
              <div class="noresult" style="display: none">
                <div class="text-center">
                  <lottie colors="primary:#121331,secondary:#08a88a" :options="defaultOptions" :height="75"
                    :width="75" />
                  <h5 class="mt-2">Sorry! No Result Found</h5>
                  <p class="text-muted mb-0">
                    We've searched more than 200k+ tasks We did not find any
                    tasks for you search.
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3" v-if="pages.length > 1">
              <div class="pagination-wrap hstack gap-2">
                <a class="page-item pagination-prev disabled" href="#" v-if="page != 1" @click="page--">
                  Previous
                </a>
                <ul class="pagination listjs-pagination mb-0">
                  <li :class="{
                              active: pageNumber == page,
                              disabled: pageNumber == '...',
                            }" v-for="(pageNumber, index) in pages.slice(
                      page - 1,
                      page + 5
                    )" :key="index" @click="page = pageNumber">
                    <a class="page" href="#">{{ pageNumber }}</a>
                  </li>
                </ul>
                <a class="page-item pagination-next" href="#" @click="page++" v-if="page < pages.length">
                  Next
                </a>
              </div>
            </div>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <!--end col-->
    </div>
    <!--end row-->

  </Layout>
</template>